import React, { useEffect } from "react";
import { useStateLoaderContext } from "providers";
import { Spinner } from "components";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export const InputCardTitle = ({ title = null, isLoading, setIsLoading }) => {
  const { isLoaderLine, isFetching } = useStateLoaderContext();
  const loadingState = useProductConfiguratorStore((state) => state.isLoading);

  // Effect 1: stop loading when loader line and fetching are done
  useEffect(() => {
    if (!isLoaderLine && !isFetching) {
      setIsLoading(false);
    }
  }, [isLoaderLine, isFetching, setIsLoading]);

  // Effect 2: stop loading when store loading finishes
  useEffect(() => {
    if (!loadingState && isLoading) {
      setIsLoading(false);
    }
  }, [isLoading, loadingState, setIsLoading]);

  if (!title) {
    return;
  }

  return (
    <div className="d-flex align-items-center mb-4">
      <h5 className="me-3 mb-0">{title}</h5>
      {isLoading && <Spinner size="xxs" />}
    </div>
  );
};
